const baseUrl = "/cloud-storage";

export const CREATE = `${baseUrl}/`;
export const FORMAT = `${baseUrl}/format/`;
export const GET_BY_ID = `${baseUrl}/`;
export const GET_BY_USER_ID = `${baseUrl}/get-by-userid/`;
export const UPDATE_BY_USER_ID = `${baseUrl}/update-by-userid/`;
export const UPDATE_SPECIFIC = `${baseUrl}/`;